<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @imp='imp'
                @del="del"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="quotationAudit" :disabled="!btn.quotationaudit">{{$t('getapi[941]')}}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="FrmRFQQuotation"
                :filter_language="['pur_status']"
                :filter_thousandth="['pur_moq']"
                :filter_thousandth_purprice="['pur_price']"
                :filter_date="['part_require_date']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                @lct="editInfo"
                :authority="!btn.edit"
        ></wTable>
       <!-- <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight  - reduceTableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[7884]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="relation_part_bc" :label="$t('getapi[7885]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_require_date" :label="$t('getapi[7889]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_buyer" :label="$t('getapi[7888]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_status" :label="$t('getapi[7887]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_vender" :label="$t('getapi[3685]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_price" :label="$t('getapi[7891]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_floor" :label="$t('getapi[7892]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_unit" :label="$t('getapi[7893]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_currency" :label="$t('getapi[6379]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_moq" :label="$t('getapi[7894]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_cycle" :label="$t('getapi[3597]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_delivery" :label="$t('getapi[7895]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_payment" :label="$t('getapi[6738]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_remark" :label="$t('getapi[7922]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_finish_date" :label="$t('getapi[7904]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4044]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_person" :label="$t('getapi[2356]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_time" :label="$t('getapi[2358]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exclusively_id" :label="$t('getapi[3137]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right"  :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope" >
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope)"  type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FrmRFQQuotation" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6545]')" queryData="FrmRFQQuotation" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="50%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[7884]')}}</td>
                        <td><el-input v-model="dataDetail.part_file" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[7885]')}}</td>
                        <td>  <el-input  type="text" v-model="dataDetail.relation_part_bc"
                                         readonly
                                         size="mini"
                                         class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRFQPart()"></i>
                        </el-input></td>
                        <td>{{$t('getapi[7889]')}}</td>
                        <td>
                            <el-date-picker v-model="dataDetail.part_require_date" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7888]')}}</td>
                        <td><el-input v-model="dataDetail.pur_buyer"></el-input></td>
                        <td>{{$t('getapi[7887]')}}</td>
                        <td><el-input v-model="dataDetail.pur_status"></el-input></td>
                        <td>{{$t('getapi[3685]')}}</td>
                        <td><el-input v-model="dataDetail.pur_vender"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7891]')}}</td>
                        <td><el-input v-model="dataDetail.pur_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      v-decimal-limit="$store.state.digitsetting.pur_price_digit"></el-input></td>
                        <td>{{$t('getapi[7892]')}}</td>
                        <td><el-input v-model="dataDetail.pur_floor"></el-input></td>
                        <td>{{$t('getapi[7893]')}}</td>
                        <td><el-input v-model="dataDetail.pur_unit"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6379]')}}</td>
                        <td><el-input v-model="dataDetail.pur_currency"></el-input></td>
                        <td>{{$t('getapi[7894]')}}</td>
                        <td><el-input v-model="dataDetail.pur_moq" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      v-decimal-limit="$store.state.digitsetting.pur_price_digit"></el-input></td>
                        <td>{{$t('getapi[3597]')}}</td>
                        <td><el-input v-model="dataDetail.pur_cycle"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7895]')}}</td>
                        <td><el-input v-model="dataDetail.pur_delivery"></el-input></td>
                        <td>{{$t('getapi[6738]')}}</td>
                        <td><el-input v-model="dataDetail.pur_payment"></el-input></td>
                        <td>{{$t('getapi[7922]')}}</td>
                        <td><el-input v-model="dataDetail.pur_remark"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7904]')}}</td>
                        <td><el-date-picker v-model="dataDetail.pur_finish_date" type="date" size="mini"
                                            style="width:100%"></el-date-picker></td>
                        <td>{{$t('getapi[410]')}}</td>
                        <td><el-input v-model="dataDetail.create_person" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[409]')}}</td>
                        <td><el-date-picker v-model="dataDetail.create_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[733]')}}</td>
                        <td><el-input v-model="dataDetail.modify_person" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[734]')}}</td>
                        <td><el-date-picker v-model="dataDetail.modify_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                        <td>{{$t('getapi[2356]')}}</td>
                        <td><el-input v-model="dataDetail.close_person" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2358]')}}</td>
                        <td><el-date-picker v-model="dataDetail.close_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                        <td>{{$t('getapi[3137]')}}</td>
                        <td><el-input v-model="dataDetail.exclusively_id" :disabled="true"></el-input></td>
                        <!--<td>{{$t('getapi[12764]')}}</td>
                        <td><el-input v-model="dataDetail.vender_code" :disabled="true"></el-input></td>-->
                    </tr>
                    <!--<tr>
                        <td>{{$t('getapi[12688]')}}</td>
                        <td><el-input v-model="dataDetail.Vender_Email" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[3139]')}}</td>
                        <td><el-input v-model="dataDetail.Manager_Person" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[8266]')}}</td>
                        <td><el-input v-model="dataDetail.Manager_PersonEmail" :disabled="true"></el-input></td>
                    </tr>-->
                </table>
            </div>
            <el-divider></el-divider>
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="100px" label-position="left" size="small">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7884]')"><el-input v-model="dataDetail.part_file" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7885]')">
                                    <el-input  type="text" v-model="dataDetail.relation_part_bc"
                                               readonly
                                               size="mini"
                                               class="mcolor"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRFQPart()"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7889]')"><el-date-picker v-model="dataDetail.part_require_date" type="date" size="mini"
                                                                           style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7888]')"><el-input v-model="dataDetail.pur_buyer"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7887]')"><el-input v-model="dataDetail.pur_status"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3685]')"><el-input v-model="dataDetail.pur_vender"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7891]')"><el-input v-model="dataDetail.pur_price" type="number" @mousewheel.native.prevent></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7892]')"><el-input v-model="dataDetail.pur_floor"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7893]')"><el-input v-model="dataDetail.pur_unit"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6379]')"><el-input v-model="dataDetail.pur_currency"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7894]')"><el-input v-model="dataDetail.pur_moq" type="number" @mousewheel.native.prevent></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3597]')"><el-input v-model="dataDetail.pur_cycle"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7895]')"><el-input v-model="dataDetail.pur_delivery"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6738]')"><el-input v-model="dataDetail.pur_payment"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7922]')"><el-input v-model="dataDetail.pur_remark"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7904]')"><el-date-picker v-model="dataDetail.pur_finish_date" type="date" size="mini"
                                                                           style="width:100%"></el-date-picker></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[410]')"><el-input v-model="dataDetail.create_person" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[409]')"><el-date-picker v-model="dataDetail.create_time" type="date" size="mini"
                                                                                         style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[733]')"><el-input v-model="dataDetail.modify_person" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[734]')"><el-date-picker v-model="dataDetail.modify_time" type="date" size="mini"
                                                                                         style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[2356]')"><el-input v-model="dataDetail.close_person" :disabled="true"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[2358]')"><el-date-picker v-model="dataDetail.close_time" type="date" size="mini"
                                                                                          style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3137]')"><el-input v-model="dataDetail.exclusively_id" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[12764]')"><el-input v-model="dataDetail.vender_code" :disabled="true"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[12688]')"><el-input v-model="dataDetail.Vender_Email" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3139]')"><el-input v-model="dataDetail.Manager_Person" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[8266]')"><el-input v-model="dataDetail.Manager_PersonEmail" :disabled="true"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>-->
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/RFQB/GetRFQPartPopupList'" @callback="getRFQPart" ref="rfqpart"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'purrfqquotation',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purrfqquotation'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [],
                btn: {
                    quotationaudit: false,
                    edit: false,
                },
                isShowEdit: false,
                dataDetail: {},
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FrmRFQQuotation', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6546]"),this.$t("getapi[17]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.authority('plv2', 234, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 234, 1) == 2) {
                    if (that.$limits.authority('plv3', 234,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 234,1) == 1) {
                        that.btn.edit = true
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                    }
                    if (that.$limits.authority('plv3', 234, 1) == 2) {
                        that.btn.edit = true
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                        }
                    }
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.quotationaudit = false
                if(that.selectData.length > 0){
                    if(that.$limits.authority('plv4', 128, 1) > 0){
                        that.btn.quotationaudit = that.selectData.every(val => {
                            return val.pur_status == '生成'
                        });
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purrfqquotation',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmRFQQuotation');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/RFQB/PurRFQQuotationDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/RFQB/PurRFQQuotationToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FrmRFQQuotation",
                    fromname: that.$t("getapi[6546]"),
                    SelectIndex: that.SelectIndexs,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            quotationAudit(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectData[i].exclusively_id,
                        pur_status: that.selectData[i].pur_status,
                        modify_time: that.selectData[i].modify_time
                    }]
                }
                let parm = {
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQQuotationAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            imp(){
                let item = {
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/23',
                    url: '/exp/23',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/exp/23' });
                this.$store.commit('selectMenu', item);
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                exclusively_id: that.selectData[i].exclusively_id,
                                modify_time: that.selectData[i].modify_time,
                                pur_status: that.selectData[i].pur_status
                            }]
                        }
                        let parm = {
                            list: arr
                        }
                        that.$http.urlpost('/Pur/RFQB/DeleteRFQQuotation', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            editInfo(row){
                let that = this
                let parm = {
                    Id: row.row.exclusively_id
                }
                that.$http.urlpost('/Pur/RFQB/GetRFQQuotationInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowEdit = true
                        that.dataDetail = res.DataContent.Head
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                that.dataDetail = {
                    exclusively_id: -1,
                    relation_part_bc: '',
                    pur_buyer: '',
                    pur_vender: '',
                    pur_price: '',
                    pur_floor: '',
                    pur_unit: '',
                    pur_currency: '',
                    pur_moq: '',
                    pur_cycle: '',
                    pur_delivery: '',
                    pur_payment: '',
                    pur_remark: '',
                    pur_finish_date: '',
                    pur_status: '草稿',
                    create_person: that.user,
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    close_person: '',
                    close_time: '',
                    vender_code: '',
                    part_file: '',
                    part_require_date: ''
                };
            },
            save(){
                let that = this
                let parm = {
                    Head: that.dataDetail
                }
                that.$http.urlpost('/Pur/RFQB/SaveRFQQuotation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            selectRFQPart(){
                let that = this;
                that.$refs.rfqpart.clearInput(true);
            },
            getRFQPart(data){
                let that = this
                console.log(data)
                that.dataDetail.part_file = data.part_file
                that.dataDetail.relation_part_bc = data.part_blueprint_code
                that.dataDetail.part_require_date = data.part_require_date
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
</style>
